import "../../messages/jquery-events.js"
import "../../messages/websocket-logic.js"


declare global {
    const convertTimeFull: (date: number) => string;
    const convertTime: (date: number, needNewLine?: boolean, onlyDate?: boolean) => string;
    var actionTimer: number;
    var isBlockActionsElement:boolean;
    var blockedElements: number[]
}
globalThis.blockedElements = [];


